/**
 * Load Bugsnag first so we can catch those errors.
 */

var Bugsnag = require('@bugsnag/js');
var BugsnagPluginReact = require('@bugsnag/plugin-react');
var BugsnagPluginVue = require('@bugsnag/plugin-vue');

Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_KEY,
    plugins: [
        new BugsnagPluginReact(),
        new BugsnagPluginVue(),
    ],
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: ['production'],
});

window.Bugsnag = Bugsnag;

/**
 * Load some required JS code.
 */
require('./modernizr');
require('./polyfills/objectassign');
// Promise polyfill. Allows us to use promises for older browsers.
require('./polyfills/promise-polyfill');
window.cap_theme = require('./util/theme');
window._ = require('lodash');
window.Popper = require('popper.js').default;
window.dayjs = require('dayjs');
dayjs.extend(require('dayjs/plugin/advancedFormat'));

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Notifier
 */
window.Notifier = require('./components/Notify/notify');

/**
 * Google analytics.
 */
const GAControl = require('./google-analytics');

/**
 * Facebook Pixel
 */
const FBQControl = require('./fbq');

/***
 * Cookie consent.
 */
const CookieConsent = require('./cookie-consent/cookie-consent');
CookieConsent.init();

CookieConsent.onChange(function (cookieState) {
    if (CookieConsent.allowsCategory('statistic')) {
        GAControl.enable();
    } else {
        GAControl.disable();
    }

    if (CookieConsent.allowsCategory('marketing')) {
        FBQControl.grant();
    } else {
        FBQControl.revoke();
    }
});

/**
 * Initialize Google analytics.
 */
GAControl.init().then(() => {
    if (CookieConsent.allowsCategory('statistic')) {
        GAControl.enable();
    }
}).catch(function (err) {
    Bugsnag.notify(err);
});

/**
 * Initial FBQ controls.
 */
if (CookieConsent.allowsCategory('marketing')) {
    FBQControl.grant();
} else {
    FBQControl.revoke();
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });